// extracted by mini-css-extract-plugin
export var ellipse = "style-module--ellipse--4DUvF";
export var ellipse2 = "style-module--ellipse2--RYC0a";
export var ellipse3 = "style-module--ellipse3--2jMZY";
export var ellipse4 = "style-module--ellipse4--6K3Ix";
export var root = "style-module--root--lAFPI";
export var root2 = "style-module--root2--OJ1X+";